import {
  Component,
  Injectable,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

interface WarningOptions {
  title: string;
  message: string;
}

@Component({
  selector: 'app-warning-dialog',
  templateUrl: 'warning-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslateModule],
})
export class WarningDialogComponent {
  private modalRef = inject(NgbActiveModal);

  public options: WarningOptions;

  public ok() {
    this.modalRef.close();
  }
}

@Injectable({ providedIn: 'root' })
export class WarningService {
  private ngbModal = inject(NgbModal);

  showWarning(options: WarningOptions) {
    const modalRef = this.ngbModal.open(WarningDialogComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
      modalDialogClass: 'modal-size-md',
    });
    modalRef.componentInstance.options = options;

    return modalRef.closed;
  }
}
